module.exports = {"130306001":"骊城街道","130306100":"抚宁镇","130306101":"留守营镇","130306102":"榆关镇","130306105":"台营镇","130306106":"大新寨镇","130306109":"坟坨镇","130306200":"茶棚乡"}


//////////////////
// WEBPACK FOOTER
// ./src/town/130306.json
// module id = 188
// module chunks = 0